// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"170":"269e56a7","316":"97208e99"}[chunkId] + ".chunk.css";
};